import styled from 'styled-components'

export const Spacer = styled.div`
  padding-bottom: 16px;
`
